import React from 'react';

export default function BatchAngkatan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Batch / Angkatan</h1>
      <p className="text-gray-500">Halaman Batch / Angkatan</p>
    </div>
  );
}
